import imagesPillarPages from '../imagesPillarPages';

export default {
  headingText: {
    title: `Build web application that your customers will love, with a little
      help of JavaScript`,
    description: `It doesn’t matter how sophisticated and fast your backend is.
      Responsive and easy to navigate frontend is the key to make
      users love your application. Besides, it’s surprisingly easy to
      achieve when you have the outstanding JavaScript developers on
      board.`,
    img: imagesPillarPages.logoJS
  },
  telecomSectionData: {
    title: 'Work with JavaScript professionals at Ulam Labs',
    description: [
      'Choosing the right technology partner for your business is not easy.',
      'At Ulam Labs, we assist you in each step of the software development, from the idea, through planning, across the development stage, till the release.',
      'We provide a comprehensive range of services for end-to-end product development, including desing, development, implementation and support. We build scalable and robust software solutions for enterprises and startups.'
    ],
    list: [
      'since 2012 on the market',
      '20+ successful projects',
      'Startups and SME oriented',
      'All range of industries: Fintech, Telco, E-commerce, and more...'
    ],
    btnText: "Let's work together"
  }
};
